if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.viewer.addEventListener("click", this._onClickFunc.bind(this));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

      // Ensure all inline videos have playsinline and muted for Safari/iOS
      this.initInlineVideos();
    }

    initInlineVideos() {
      // Find all inline video elements and ensure correct attributes
      this.elements.viewer.querySelectorAll('.product__inline-video video').forEach(video => {
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        // Pause all videos initially - only active slide should play
        video.pause();
      });

      // Play the video in the active slide (if any)
      const activeSlide = this.elements.viewer.querySelector('.is-active .product__inline-video video');
      if (activeSlide) {
        activeSlide.play().catch(() => {});
      }
    }

    _onClickFunc(event) {
      // If clicking on an inline video slide, do nothing (let the video play)
      const clickedSlide = event.target.closest('[data-media-id]');
      if (clickedSlide && clickedSlide.querySelector('.product__inline-video video')) {
        return;
      }

      // If clicking on an external video (deferred-media), load it
      if (clickedSlide) {
        const deferredMedia = clickedSlide.querySelector('deferred-media');
        if (deferredMedia) {
          this.loadExternalVideo(deferredMedia);
          return;
        }
      }

      // Default: navigate between slides via left/right click
      if(event.offsetX > this.offsetWidth / 2) {
        let val = false;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
           if(mediaToSwitch.querySelector('button').getAttribute('aria-current') && val == false && index < this.elements.thumbnails.querySelectorAll('[data-target]').length - 1 ) {
            let nextEle = this.elements.thumbnails.querySelectorAll('[data-target]')[index+1];
            this.setActiveMedia(nextEle.dataset.target, false);
            val = true;
           }
        });
      }else {
        let val = false;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
           if(mediaToSwitch.querySelector('button').getAttribute('aria-current') && val == false && index > 0 ) {
            let nextEle = this.elements.thumbnails.querySelectorAll('[data-target]')[index-1];
            this.setActiveMedia(nextEle.dataset.target, false);
            val = true;
           }
      });
    }
    }

    loadExternalVideo(deferredMedia) {
      if (deferredMedia.getAttribute('loaded')) return;

      const template = deferredMedia.querySelector('template');
      if (!template) return;

      const content = document.createElement('div');
      content.appendChild(template.content.firstElementChild.cloneNode(true));

      const iframe = content.querySelector('iframe');
      if (iframe) {
        iframe.setAttribute('allow', 'autoplay; encrypted-media');
      }

      deferredMedia.setAttribute('loaded', true);
      deferredMedia.appendChild(content.querySelector('video, model-viewer, iframe'));

      const poster = deferredMedia.querySelector('.deferred-media__poster');
      if (poster) poster.style.display = 'none';
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
      this.playActiveMedia(event.detail.currentElement);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      // Pause all media first
      window.pauseAllMedia();

      // Play inline video if present in the active slide
      const inlineVideo = activeItem.querySelector('.product__inline-video video');
      if (inlineVideo) {
        inlineVideo.play().catch(() => {});
        return;
      }

      // Load external video (deferred) if present
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) {
        this.loadExternalVideo(deferredMedia);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
